export const USER_STORAGE_KEY = "twdb_metadata_user";

// How often we should refresh queries (like fetching records for status updates)
// Currently set to 1 hour.
export const QUERY_REFRESH_INTERVAL_MS = 1000 * 60;
